import { render, staticRenderFns } from "./ConnectModuleCourseSlidebar.vue?vue&type=template&id=e3047488&scoped=true"
import script from "./ConnectModuleCourseSlidebar.vue?vue&type=script&lang=js"
export * from "./ConnectModuleCourseSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3047488",
  null
  
)

export default component.exports